var sharp_RRMCG0101AJSA = {
    name: "RRMCG0101AJSA",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,224,146,95,117,116,128],
        },
        {
            function: "KEY_EJECTCD",
            name: "KEY_EJECTCD",
            icon: "KEY_EJECTCD",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,224,146,95,174,180,128],
        },
        {
            // function: "tv_vcr",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,188,152,94,187,217],
        },
        {
            function: "input",
            name: "input",
            icon: "input",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,4,141,213,218,236,128],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,152,158,95,119,178],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,4,141,170,237,236,128],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,152,158,125,183,178],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,40,135,213,123,217],
        },
        {
            function: "instant_replay",
            name: "instant_replay",
            icon: "instant_replay",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,188,152,95,221,89],
        },
        {
            function: "KEY_AGAIN",
            name: "KEY_AGAIN",
            icon: "KEY_AGAIN",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,4,141,213,238,172,128],
        },
        {
            function: "skip_search",
            name: "skip_search",
            icon: "skip_search",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,152,158,95,238,178],
        },
        {
            function: "KEY_NEXT",
            name: "KEY_NEXT",
            icon: "KEY_NEXT",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,40,135,213,247,89],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,152,158,95,123,178],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,4,141,213,94,236,128],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,152,158,94,251,178],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,224,146,95,214,180,128],
        },
        {
            function: "KEY_RECORD",
            name: "KEY_RECORD",
            icon: "KEY_RECORD",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,152,158,95,219,178],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,4,141,213,110,236,128],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,116,164,94,255,100],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,76,129,213,191,178],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,152,158,94,191,178],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,76,129,213,223,178],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,152,158,94,223,178],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,40,135,213,175,217],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,188,152,94,175,217],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,76,129,213,239,178],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,152,158,94,239,178],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,152,158,95,222,178],
        },
        {
            function: "tamper_proof",
            name: "tamper_proof",
            icon: "tamper_proof",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,4,141,213,107,236,128],
        },
        {
            function: "tape_speed",
            name: "tape_speed",
            icon: "tape_speed",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,4,141,213,250,180,128],
        },
        {
            function: "display",
            name: "display",
            icon: "display",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,4,141,213,215,172,128],
        },
        {
            function: "KEY_CANCEL",
            name: "KEY_CANCEL",
            icon: "KEY_CANCEL",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,152,158,95,190,178],
        },
        {
            function: "zero_back",
            name: "zero_back",
            icon: "zero_back",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,4,141,213,95,172,128],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,224,146,94,213,236,128],
        },
        {
            function: "KEY_SLOW",
            name: "KEY_SLOW",
            icon: "KEY_SLOW",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,4,141,213,118,236,128],
        },
        {
            function: "slow_dpss_minus",
            name: "slow_dpss_minus",
            icon: "slow_dpss_minus",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,152,158,95,235,178],
        },
        {
            function: "dpss_minus",
            name: "dpss_minus",
            icon: "dpss_minus",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,40,135,213,245,217],
        },
        {
            function: "slow_dpss_plus",
            name: "slow_dpss_plus",
            icon: "slow_dpss_plus",
            command: [32,0,3,144,1,96,9,144,1,132,3,144,1,4,141,213,246,180,128],
        },
        {
            function: "dpss_plus",
            name: "dpss_plus",
            icon: "dpss_plus",
            command: [32,0,3,144,1,132,3,144,1,96,9,144,1,188,152,95,237,105],
        },
    ]
}
export default sharp_RRMCG0101AJSA